var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/functional/filters") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6214696,9.56979956 L3.75038468,9.56979956 C3.33595866,9.56979956 3,9.56979956 3,8.81979956 C3,8.06979956 3.33595866,8.06979956 3.75038468,8.06979956 L15.5819706,8.06979956 C15.8847037,6.88000382 16.9631847,6 18.2472016,6 C19.7659847,6 20.9972016,7.23121694 20.9972016,8.75 C20.9972016,10.2687831 19.7659847,11.5 18.2472016,11.5 C17.0139378,11.5 15.9702826,10.6881887 15.6214696,9.56979956 Z M18.2472016,10 C18.9375575,10 19.4972016,9.44035594 19.4972016,8.75 C19.4972016,8.05964406 18.9375575,7.5 18.2472016,7.5 C17.5568457,7.5 16.9972016,8.05964406 16.9972016,8.75 C16.9972016,9.44035594 17.5568457,10 18.2472016,10 Z M8.39789424,14.72 L20.2496153,14.72 C20.6640413,14.72 21,14.72 21,15.47 C21,16.22 20.6640413,16.22 20.2496153,16.22 L8.39789424,16.22 C8.0714298,17.3742524 7.01018761,18.22 5.75141048,18.22 C4.23262742,18.22 3.00141048,16.9887831 3.00141048,15.47 C3.00141048,13.9512169 4.23262742,12.72 5.75141048,12.72 C7.01018761,12.72 8.0714298,13.5657476 8.39789424,14.72 Z M5.75141048,16.72 C6.44176642,16.72 7.00141048,16.1603559 7.00141048,15.47 C7.00141048,14.7796441 6.44176642,14.22 5.75141048,14.22 C5.06105455,14.22 4.50141048,14.7796441 4.50141048,15.47 C4.50141048,16.1603559 5.06105455,16.72 5.75141048,16.72 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/functional/filters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/grey",
    mask: "url(#mask-2)",
    fill: "#99A9BB"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.653c83e18ed9d1215cba37edb70f20a8.svg";
export { ForwardRef as ReactComponent };